<app-navbar (redirectToWelcome)="redirectToWelcome()"></app-navbar>
<div
  class="container vh-100 flex-column justify-content-center align-items-center content-below-navbar"
>
  <div class="header-container">
    <div class="logo-grid">
      <!-- School Logo Section -->
      <div class="logo-section">
        <img
          [src]="
            schoolInfo()?.logo?.url ||
            'https://assets.simpliedtech.com/logo_light'
          "
          alt="School Logo"
          class="logo-image"
        />
        <h1 class="logo-text">{{ schoolInfo()?.name || 'School Name' }}</h1>
      </div>

      <!-- Simplied Logo Section -->
      <div class="logo-section simplied-section">
        <img
          src="https://assets.simpliedtech.com/logo_light"
          alt="Simplied Logo"
          class="logo-image"
        />
        <h1 class="logo-text ft-40px">SimpliEd</h1>
      </div>
    </div>
  </div>

  <div class="row w-100">
    <div class="col-md-12 mt-md-3 mt-0 height-on-small">
      <div class="dashboard-generic-box-white position-relative">
        <div class="d-flex flex-row text-width">
          <div class="d-flex flex-column">
            <div
              class="d-flex flex-column admission-text-container pt-5 pb-md-5 pb-2 px-4 padding-left-right"
            >
              <h2 class="welcome-heading">
                <span
                  ><svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_19617_88086)">
                      <path
                        d="M37.5 22.918C37.5 24.3138 37.5 25.6888 37.5 27.0846C40 27.0846 43.25 27.0846 45.8333 27.0846C45.8333 25.6888 45.8333 24.3138 45.8333 22.918C43.25 22.918 40 22.918 37.5 22.918Z"
                        fill="#3C26BF"
                      />
                      <path
                        d="M33.3333 36.6862C35.3333 38.1654 37.9374 40.1237 39.9999 41.6654C40.8333 40.5612 41.6666 39.4362 42.4999 38.332C40.4374 36.7904 37.8333 34.832 35.8333 33.332C34.9999 34.457 34.1666 35.582 33.3333 36.6862Z"
                        fill="#3C26BF"
                      />
                      <path
                        d="M42.4999 11.6654C41.6666 10.5612 40.8333 9.4362 39.9999 8.33203C37.9374 9.8737 35.3333 11.832 33.3333 13.332C34.1666 14.4362 34.9999 15.5612 35.8333 16.6654C37.8333 15.1654 40.4374 13.2279 42.4999 11.6654Z"
                        fill="#3C26BF"
                      />
                      <path
                        d="M8.33341 18.75C6.04175 18.75 4.16675 20.625 4.16675 22.9167V27.0833C4.16675 29.375 6.04175 31.25 8.33341 31.25H10.4167V39.5833H14.5834V31.25H16.6667L27.0834 37.5V12.5L16.6667 18.75H8.33341ZM18.8126 22.3125L22.9167 19.8542V30.1458L18.8126 27.6875L17.8126 27.0833H16.6667H8.33341V22.9167H16.6667H17.8126L18.8126 22.3125Z"
                        fill="#3C26BF"
                      />
                      <path
                        d="M32.2917 24.9987C32.2917 22.2279 31.0834 19.7279 29.1667 18.0195V31.957C31.0834 30.2695 32.2917 27.7695 32.2917 24.9987Z"
                        fill="#3C26BF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_19617_88086">
                        <rect width="50" height="50" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span class="pl-3 admission-text">Admission. Made Simple</span>
              </h2>
              <p class="welcome-text">
                We’re excited to have you start your journey with us! Our
                streamlined admissions process is designed to be simple and
                clear. Follow the steps to submit your application and take the
                next step towards achieving your goals.
              </p>
            </div>
            <div
              class="d-flex mt-md-5 mt-0 flex-column align-items-center justify-content-center"
            >
              <!-- <div class="d-flex mb-4 fw-700">Ready to Apply?</div> -->
              <div class="d-flex form-group pb-2">
                <button
                  type="button"
                  class="w-100 btn round-button main-button d-flex align-items-center justify-content-center"
                  name="login_btn"
                  (click)="onContinue()"
                >
                  <span>Apply Now</span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="Example home icon"
                    class="arrow-icon icons-navs-mat"
                    fontSet="material-icons-outlined"
                  >
                    arrow_forward
                  </mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="align-items-center mt-4 pr-2 hide-on-small">
            <img
              src="../../../assets/images/registration-welcome-page-icon.png"
              class="img-size"
              alt="Welcome Image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
